module.exports = __webpack_public_path__ + "media/images/emoticons/r-mark-4d22226e08aa45496e2265ca4e741eab.gif";